import React, { Fragment, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Box,
  Heading,
  Text,
  useColorModeValue,
  Image,
  Link,
  HStack,
  SimpleGrid,
  GridItem,
  Flex,
  VStack,
} from "@chakra-ui/react";
import dayjs from "dayjs";

export const BlogAuthor = (props) => (
  <HStack ml={2} mt="0" spacing="2" alignItems="center">
    <Box>
      <Text fontSize="xs">{props.name}</Text>
      <Text fontSize="xs">{dayjs(props?.date).format("DD MMMM YYYY")}</Text>
    </Box>
  </HStack>
);

const SubjectLayoutAllCourse = ({
  subject,
  subjectsState,
  id,
  user,
  onOpen,
  curPage,
  itemLimit,
  curItems,
  setCurItems,
}) => {
  const history = useHistory();
  const color = useColorModeValue("gray.500", "gray.300");

  useEffect(() => {
    const offset = curPage * itemLimit;
    setCurItems(subjectsState.slice(offset, offset + itemLimit));
  }, [curPage, itemLimit, subjectsState]);

  const handleSubjectRoute = (subjectId) => {
    if (subject?.contentfor === "VIP") {
      if (user?.member === "VIP" || user?._id === subject?.teacher?._id) {
        history.push(`/subject/${subjectId}`);
      } else {
        onOpen();
      }
    } else {
      history.push(`/subject/${subjectId}`);
    }
  };

  return (
    <SimpleGrid
      columns={{ base: 1, sm: 2, md: 3, lg: 4 }}
      spacingX={{ base: 5, lg: 10 }}
      w="full"
      minH="70vh"
    >
      {curItems?.map((subject) => (
        <GridItem key={subject?._id} w="100%" mt={5}>
          {subject?.status === "public" && (
            <Link onClick={() => handleSubjectRoute(subject?._id)}>
              <Box
                borderRadius="lg"
                borderWidth="2px"
                boxShadow="xl"
                overflow="hidden"
                height="300px" // fixed height for uniformity
                display="flex"
                flexDirection="column"
                _hover={{ transform: "scale(1.01)", transition: "0.3s" }}
              >
                {/* Image Section */}
                <Box position="relative" h="70%">
                  <Image
                    src={
                      subject?.photo ||
                      "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=1350&q=80"
                    }
                    alt={subject?.name}
                    objectFit="cover"
                    w="full"
                    h="full"
                  />
                  <Box
                    position="absolute"
                    top="0"
                    left="0"
                    w="100%"
                    h="100%"
                    bg="rgba(0, 0, 0, 0.6)"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text
                      color="white"
                      fontWeight="bold"
                      fontSize="lg"
                      textAlign="center"
                      px={2}
                      noOfLines={2}
                    >
                      {subject?.name}
                    </Text>
                  </Box>
                </Box>

                {/* Description Section */}
                <Flex direction="column" justify="space-between" h="30%" p={3}>
                  <Text fontSize="sm" color={color} noOfLines={2}>
                    {subject?.description}
                  </Text>
                  <Text
                    fontSize="xs"
                    color={color}
                    fontStyle="italic"
                    textAlign="right"
                  >
                    {subject?.teacher?.firstname} {subject?.teacher?.lastname}
                  </Text>
                </Flex>
              </Box>
            </Link>
          )}
        </GridItem>
      ))}
    </SimpleGrid>
  );
};

SubjectLayoutAllCourse.propTypes = {
  subject: PropTypes.shape(),
  user: PropTypes.shape(),
  id: PropTypes.string,
  onOpen: PropTypes.func,
  curPage: PropTypes.number,
  itemLimit: PropTypes.number,
  curItems: PropTypes.array,
  setCurItems: PropTypes.func,
};

SubjectLayoutAllCourse.defaultProps = {
  subject: {},
  user: {},
  id: "",
  onOpen: () => {},
};

export default SubjectLayoutAllCourse;
